import { StoreHelpers } from '../helpers/StoreHelpers';
import { ISiteNameSansId } from '../serverApi/types/ISiteNameSansId';
import { SiteNameSansIds } from '../services/resources/SiteNameSansIds';

export class SiteStore {

  constructor(private siteNames: SiteNameSansIds) { }

  public getAll(): Q.Promise<ISiteNameSansId[]> {
    return StoreHelpers.getAll<ISiteNameSansId>(this.siteNames.all());
  }

}
